import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetBackCountsInProgressCount } from "../states/audits/audits.actions";
import { ActivityTypesEnum } from "../interfaces/ActivityTypesEnum";
import { DrugScheduleEnum } from "../interfaces/DrugScheduleEnum ";
import { PharmacyState } from "../states/pharmacy/pharmacy.state";

@Injectable({ providedIn: 'root'})
export class BackCountService {

    /**
     * Stores drug IDs for which back count is enabled
     */
    private enabledBackCountIDs: Set<string> = new Set();

    constructor(private store: Store) {
    }

    handleBackCountPillUpdate(payload: any | any[]): void {
      let shouldUpdate = false;

      if (Array.isArray(payload)) {
          for (const item of payload) {
              if (Array.isArray(item)) {
                  shouldUpdate = item.some((entity) => this.shouldUpdateBackCountPillPredicate(entity));
              } else {
                  shouldUpdate = this.shouldUpdateBackCountPillPredicate(item) || shouldUpdate;
              }

              if (shouldUpdate) {
                  break;
              }
          }
      } else {
        shouldUpdate = this.shouldUpdateBackCountPillPredicate(payload);
      }

      if (shouldUpdate) {
          this.store.dispatch(new GetBackCountsInProgressCount());
      }
    }

    private shouldUpdateBackCountPillPredicate(entity: any) {
        return entity?.isBackCountMatches === false
    }
    /**
     * Saves drugID to the internal Set if back count for it enabled
     * @param activityType 
     * @param schedule 
     * @returns True if the drug requires a back-count
     */
    enabledForActivityAndSchedule(activityType: ActivityTypesEnum, schedule: DrugScheduleEnum, drugId?: string): boolean {
     const backCountEnabledForTheActivity = this.store.selectSnapshot(PharmacyState.backCountValue)?.findIndex(x => x.ActivityType === activityType && x.Schedules.includes(schedule)) > -1;
     if (backCountEnabledForTheActivity && drugId) {
      this.enabledBackCountIDs.add(drugId);
     }
     return backCountEnabledForTheActivity;
    }
    /**
     * 
     * @returns a copy of internal collection
     */
    getDrugIDsRequiringBackCount(): Set<string> {
      return new Set(this.enabledBackCountIDs);
    }

    removeDrugIDRequiringBackCount(drugID: string): void {
      this.enabledBackCountIDs.delete(drugID);
    }

    isDrugRequiresBackCount(drugId: string): boolean {
     return this.enabledBackCountIDs.has(drugId);
    }
    
    isAnyRequiresBackCount(): boolean {
      return this.enabledBackCountIDs.size > 0;
    }

}
